import SignUpEmailPage from 'src/modules/SignUp/SignUpEmailPage';

export default SignUpEmailPage;
